import React, { useState, useEffect, useContext } from 'react';
import Head from 'next/head';
import dynamic from 'next/dynamic';
const Footer = dynamic(() => import('@/features/allHome/components/Footer/Footer'), { ssr: false });
const Header = dynamic(() => import('@/features/allHome/components/Header/Header'), { ssr: false });
import initializeIconLibrary from '@/utils/fontAwesomeLibrary';
import 'bootstrap/dist/css/bootstrap.min.css';
import classes from '@/features/allHome/styles/pages.module.scss';
import WithStandardLayout from '@/layouts/withStandard.layout';
import Config from '@/features/allHome/json/config.json';
import { languageContext } from '@/context/language.context';
import useMixpanel from '@/hooks/useMixpanel';
import AssessmentWizard from '@/features/allHome/containers/Assessment/AssessmentWizard/AssessmentWizard';
import { StateProvider } from '@/features/allHome/context/state.context';
import { buildServerSideProps } from '@/utils/server';

initializeIconLibrary();

const AllHomePage = (props) => {
  const [config, setConfig] = useState([]);
  const { track } = useMixpanel('Stay_Housed_Bay_Area');
  const { setLanguage } = useContext(languageContext);

  const languageChangeHandler = (event) => {
    const newState = Object.assign({}, config);
    newState.languageSettings.selected = event?.target?.value || 'en';
    setLanguage(event?.target?.value);
    setConfig(newState);
  };

  const getHashParams = () => {
    let page = '';
    if (typeof window !== 'undefined') {
      page = window?.location?.hash;
    }
    return page;
  };

  useEffect(() => {
    track('Step in Stay_Housed_Bay_Area', { step: 'Started assessment' });
  }, []);

  useEffect(() => {
    setConfig(props.Config);
  }, [props.Config]);

  return (
    <div className={classes.container}>
      <a href="#site-menu" className={classes['sr-only']}>
        Skip to site menu
      </a>
      <a href="#content" className={classes['sr-only']}>
        Skip to main content
      </a>
      <a href="#ResourceSearchWizard" className={classes['sr-only']}>
        Skip to search
      </a>
      <Head>
        <title>Stay Housed Bay Area</title>
        <meta
          name="description"
          content="Resources for Bay Area residents to get the help they need to keep their housing, like rental assistance and legal services."
        />
      </Head>
      <Header config={props.Config} changeLanguage={languageChangeHandler} />
      <AssessmentWizard config={props.Config.pages.assessment} page={getHashParams()} />
      <Footer config={props.Config} changeLanguage={languageChangeHandler} />
    </div>
  );
};

export const getServerSideProps = buildServerSideProps((context, args) => {
  args.props.Config = Config; // TODO this doesn't need to be a prop, it's being imported
  return args;
});

// https://nextjs.org/docs/basic-features/layouts
// Layouts can be nested, we could use that functionality to make sure we include the Providers
// and data that every page requires
AllHomePage.getLayout = function getLayout(page) {
  return (
    <WithStandardLayout host={page.props.host}>
      <StateProvider>{page}</StateProvider>
    </WithStandardLayout>
  );
};

export default AllHomePage;
